import script from "./InstituteDashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstituteDashboardPage.vue?vue&type=script&setup=true&lang=js"

import "./InstituteDashboardPage.vue?vue&type=style&index=0&id=8397f04e&lang=css"

const __exports__ = script;

export default __exports__